import React, { useState, useEffect } from "react";
import { Typography, Card, CardContent, Grid, Button } from "@mui/material";
import { FcLike, FcLikePlaceholder } from "react-icons/fc";
import { useNavigate, Link } from "react-router-dom";
import AliceCarousel from "react-alice-carousel";
import { addItemToCart } from "../../../Redux/Customers/Cart/Action";
import "react-alice-carousel/lib/alice-carousel.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../config/api";
import { useDispatch, useSelector } from "react-redux";
import { RadioGroup } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

toast.configure();

function TopcategoryHomeCarousel({ data = [], section }) {
  const [wishlist, setWishlist] = useState([]);

  // // Use separate selectors to avoid unnecessary re-renders
  // const isLoggedIn = useSelector((state) => !!state.auth.user);
  // const token = useSelector((state) => state.auth.user?.jwt);

  // useEffect(() => {
  //   const fetchWishlist = async () => {
  //     try {
  //       const response = await api.get("/api/wishlist/get", {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       setWishlist(response.data.wishlist.products || []); // Save wishlist products or empty array
  //     } catch (error) {
  //       console.error("Error fetching wishlist:", error);
  //     }
  //   };

  //   if (isLoggedIn) {
  //     fetchWishlist();
  //   }
  // }, [isLoggedIn, token]);

  const responsive = {
    0: { items: 2, itemsFit: "contain" },
    720: { items: 3, itemsFit: "contain" },
    1024: { items: 5, itemsFit: "contain" },
  };

  return (
    <div>
      {Array.isArray(data) &&
        data.map((category) => (
          <div key={category.categoryId} className="mb-10">
            <h2 className="text-xl font-bold text-center">
              {category.categoryName.toUpperCase()}
            </h2>
            <AliceCarousel
              autoPlayInterval={2000}
              disableButtonsControls
              items={
                category.products?.map((product) => (
                  <ProductList
                    key={product.id}
                    product={product}
                    wishlist={wishlist}
                  />
                )) ?? []
              }
              responsive={responsive}
              controlsStrategy="alternate"
              mouseTracking
              infinite
            />
          </div>
        ))}
    </div>
  );
}

const ProductList = ({ product, wishlist }) => {
  const jwt = localStorage.getItem("jwt");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedSize, setSelectedSize] = useState(
    product?.sizes?.[0]?.name || ""
  );
  const [display, setDisplay] = useState(false);
  const [like, setLike] = useState(
    wishlist.some((item) => item._id === product.id)
  );

  const cardClasses =
    " bg-white w-[95%] p-2 md:w-[80%] h-[40vh] md:h-[50vh] shadow-sm shadow-yellow-800 relative mb-5";
  const buttonClasses =
    " text-yellow-700 border border-yellow-900 hover:text-white w-[60%] hover:bg-yellow-700 mt-4 px-4 py-2 rounded";

  const toggleLike = async () => {
    if (!jwt) {
      toast.error("Please log in to add item into wishlist");
      return;
    }
    try {
      if (like) {
        await api.delete(`/api/wishlist/delete/${product.id}`);
      } else {
        await api.post(`/api/wishlist/add/${product.id}`);
      }
      setLike(!like);
    } catch (error) {
      if (error.status == 400) {
        setLike(!like);
        toast.error(error.response.data.message);
      }
    }
  };

  const handleSize = () => {
    setDisplay(!display);
    console.log(display);
  };

  const addToCart = (productId, selectedSize) => {
    if (!selectedSize) {
      toast.error("Please select a size before adding to the cart.");
      setDisplay(true);
      return;
    }
    const data = { productId, size: selectedSize };
    if(jwt){
    dispatch(addItemToCart({ data, jwt }))
    toast.success("Product Added Successfully");
    }else{
       toast.error("Please Log In to add item in cart!");
    }


    setDisplay(false);

    // navigate("/cart");
  };

  return (
    <div>
      <div className={cardClasses}>
        <Link to={`product/${product.id}`}>
          <div className="h-[50%] min-w-fit">
            <img
              src={
                Array.isArray(product.imageUrl)
                  ? product.imageUrl[0]
                  : product.imageUrl
              }
              alt={product.title}
              className="w-full h-full object-contain"
            />
          </div>
          </Link>
          
          <div className="md:mt-5 mt-2 h-[20%] mx-1 md:mx-4 flex justify-between">
          <Link to={`product/${product.id}`}>
            <div className="space-y-2 mr-2">
              <h3 className="md:text-lg text-sm text-yellow-900 md:font-medium">
                {product.brand.toUpperCase()}
              </h3>
              {/* <h3 className="font-semibold text-yellow-600 mt-2">{product.title}</h3> */}

              <p className="md:text-md text-xs text-yellow-900">
                {product?.wight || 300}ML
              </p>
              <p className="md:text-md text-xs text-yellow-900">{product.price}Rs</p>
              <p className="text-muted-foreground text-yellow-900">
                {product.location}
              </p>
              </div>
              </Link>
              <div>
              <button onClick={toggleLike} className="">
                {like ? (
                  <FcLike className="text-2xl" />
                ) : (
                  <FcLikePlaceholder className="text-2xl" />
                )}
              </button>
              </div>
         
          </div>
      
        <div className=" text-center m-2">
          <button className={buttonClasses} onClick={handleSize}>
            Buy
          </button>
        </div>

        <div className={display ? "block" : "hidden" + " mt-10"}>
          <RadioGroup
            value={selectedSize}
            onChange={(size) => {
              setSelectedSize(size); // Update the selected size
              addToCart(product.id, size); // Immediately add to cart with the selected size
            }}
            className="mt-4"
          >
            <div className="grid grid-cols-3 gap-6">
              {Array.isArray(product?.size)
                ? product.size.map((size) => (
                    <RadioGroup.Option
                      key={size.name}
                      value={size.name}
                      disabled={size.quantity <= 0} // Disable out-of-stock sizes
                      className={({ active }) =>
                        classNames(
                          size.quantity > 0
                            ? "cursor-pointer bg-white text-gray-900 shadow-lg px-2"
                            : "cursor-not-allowed bg-gray-50 text-gray-200",
                          active ? "ring-1 ring-indigo-500" : "",
                          "group relative flex items-center justify-center rounded-md border px-1 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 py-3"
                        )
                      }
                    >
                      {({ active, checked }) => (
                        <>
                          <RadioGroup.Label as="span">
                            {size.name}
                          </RadioGroup.Label>
                          {size.quantity > 0 ? (
                            <span
                              className={classNames(
                                active ? "border" : "border-2",
                                checked
                                  ? "border-indigo-500"
                                  : "border-transparent",
                                "pointer-events-none absolute -inset-px rounded-md"
                              )}
                              aria-hidden="true"
                            />
                          ) : (
                            <span
                              aria-hidden="true"
                              className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                            >
                              <svg
                                className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                viewBox="0 0 100 100"
                                preserveAspectRatio="none"
                                stroke="currentColor"
                              >
                                <line
                                  x1={0}
                                  y1={100}
                                  x2={100}
                                  y2={0}
                                  vectorEffect="non-scaling-stroke"
                                />
                              </svg>
                            </span>
                          )}
                        </>
                      )}
                    </RadioGroup.Option>
                  ))
                : // Fallback sizes if no product sizes are available
                  [
                    { name: "S", quantity: 3 },
                    { name: "M", quantity: 4 },
                    { name: "L", quantity: 2 },
                  ].map((size) => (
                    <RadioGroup.Option
                      key={size.name}
                      value={size.name}
                      disabled={size.quantity <= 0}
                      className={({ active }) =>
                        classNames(
                          size.quantity > 0
                            ? "cursor-pointer bg-white text-gray-900 shadow-lg py-2"
                            : "cursor-not-allowed bg-gray-50 text-gray-200",
                          active ? "ring-1 ring-indigo-500" : "",
                          "group relative flex items-center justify-center rounded-md border px-1 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 py-3"
                        )
                      }
                    >
                      {({ active, checked }) => (
                        <>
                          <RadioGroup.Label as="span">
                            {size.name}
                          </RadioGroup.Label>
                          {size.quantity > 0 ? (
                            <span
                              className={classNames(
                                active ? "border" : "border-2",
                                checked
                                  ? "border-indigo-500"
                                  : "border-transparent",
                                "pointer-events-none absolute -inset-px rounded-md"
                              )}
                              aria-hidden="true"
                            />
                          ) : (
                            <span
                              aria-hidden="true"
                              className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                            >
                              <svg
                                className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                viewBox="0 0 100 100"
                                preserveAspectRatio="none"
                                stroke="currentColor"
                              >
                                <line
                                  x1={0}
                                  y1={100}
                                  x2={100}
                                  y2={0}
                                  vectorEffect="non-scaling-stroke"
                                />
                              </svg>
                            </span>
                          )}
                        </>
                      )}
                    </RadioGroup.Option>
                  ))}
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};

export { ProductList, TopcategoryHomeCarousel };
